import React, { useEffect, useState } from 'react';

// Small dialog to edit the line printed at the bottom of every report page.
// `profileDefault` is built from the user's profile (company name + website); the user can pull it
// back in with one click, or type anything they like. An empty value means "use the profile default".
const MAX_LEN = 160;

export default function ReportFooterModal({ open, value, profileDefault, onSave, onClose }) {
  const [text, setText] = useState(value || '');

  useEffect(() => { if (open) setText(value || ''); }, [open, value]);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const shown = text.trim() || profileDefault || 'May Vastu bring peace, happiness, prosperity always';
  const btn = { height: 36, padding: '0 16px', borderRadius: 8, fontSize: '0.8rem', fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' };

  return (
    <div
      style={{ position: 'fixed', inset: 0, zIndex: 100000, background: 'rgba(15,23,42,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
      onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{ width: '100%', maxWidth: 520, background: '#fff', borderRadius: 14, boxShadow: '0 20px 50px rgba(15,23,42,0.35)', padding: 22, fontFamily: "'Inter','Segoe UI',system-ui,sans-serif", textAlign: 'left' }}>
        <div style={{ fontSize: '1.02rem', fontWeight: 700, color: '#1A1F36' }}>Report Footer</div>
        <div style={{ fontSize: '0.78rem', color: '#64748b', margin: '4px 0 14px' }}>
          This line is printed at the bottom of every report page. Leave it empty to use your profile details.
        </div>

        <textarea
          value={text}
          maxLength={MAX_LEN}
          rows={3}
          onChange={(e) => setText(e.target.value)}
          placeholder={profileDefault || 'Type the footer text…'}
          style={{ width: '100%', boxSizing: 'border-box', border: '1.5px solid #DCE0E8', borderRadius: 10, padding: '10px 12px', fontSize: '0.86rem', fontFamily: 'inherit', resize: 'vertical', outline: 'none' }}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '6px 0 14px' }}>
          <button
            type="button"
            onClick={() => setText(profileDefault || '')}
            disabled={!profileDefault}
            style={{ ...btn, height: 30, padding: '0 12px', background: '#E6F6F5', border: '1px solid #BFE6E4', color: '#00857E', opacity: profileDefault ? 1 : 0.5, cursor: profileDefault ? 'pointer' : 'not-allowed' }}
            title={profileDefault ? 'Fill from your profile (company name and website)' : 'Add a company name or website in Update Profile first'}
          >
            Use my profile details
          </button>
          <span style={{ fontSize: '0.72rem', color: '#94a3b8' }}>{text.length}/{MAX_LEN}</span>
        </div>

        <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#8A94A6', letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: 6 }}>Preview</div>
        <div style={{ border: '1px solid #E2E8F0', borderRadius: 10, padding: '14px 10px', textAlign: 'center', fontStyle: 'italic', fontSize: '0.82rem', color: '#4A5568', background: '#FBFCFE', wordBreak: 'break-word' }}>
          {shown}
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 18 }}>
          <button type="button" onClick={onClose} style={{ ...btn, background: '#fff', border: '1px solid #DCE0E8', color: '#475569' }}>Cancel</button>
          <button type="button" onClick={() => onSave(text.trim())} style={{ ...btn, background: '#00A19D', border: 'none', color: '#fff', boxShadow: '0 3px 10px rgba(0,161,157,0.25)' }}>Save</button>
        </div>
      </div>
    </div>
  );
}
